// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createTransactionsSlice, TransactionsActions } from './createTransactionsSlice';
import { TransactionsState, transactionsInitialState } from './transactionsInitialState';
import { FilterType } from '../../components/Transactions/FiltersDivers/TagRendering/TagMapping';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la balance comptable.
 */
export const useTransactionsStore = create<TransactionsState & TransactionsActions>()(
  persist(
    (set, get, store) => ({
      ...transactionsInitialState,
      ...createTransactionsSlice(set, get, store),
    }),
    {
      name: 'transactions-store',
      partialize: (state) => ({
        ...state,
        savedFilters: Array.from(state.savedFilters.entries()),
      }),
      merge: (persistedState: any, currentState) => ({
        ...currentState,
        ...persistedState,
        savedFilters: new Map(persistedState.savedFilters as [FilterType, any][]),
      }),
    },
  ),
);
